/**
 * @desc 红人管理-申请领用
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(body: defs.kol.UseCelebrityRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/consuming`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
